import React from 'react';
import { Badge, Text, VStack } from '@chakra-ui/react';
import { DEADLINE_STATUS_COLORS, getRefundDeadlineInfo } from 'api/administrador/refunds';

export default function RefundDeadlineBadge({ refund, showDueDate = false, compact = false }) {
  const info = getRefundDeadlineInfo(refund);

  if (!info.applies) {
    return showDueDate ? (
      <Text fontSize="sm" color="gray.400">
        —
      </Text>
    ) : null;
  }

  const colors = DEADLINE_STATUS_COLORS[info.deadlineStatus];

  if (compact) {
    return (
      <VStack align="flex-start" spacing={1}>
        {showDueDate && (
          <Text fontSize="sm" color="gray.700" whiteSpace="nowrap">
            {info.dueDateFormatted}
          </Text>
        )}
        <Badge
          px={2}
          py={0.5}
          borderRadius="full"
          fontSize="2xs"
          fontWeight="bold"
          bg={colors.bg}
          color={colors.color}
          border="1px solid"
          borderColor={colors.borderColor}
          textTransform="uppercase"
        >
          {info.statusLabel}
        </Badge>
      </VStack>
    );
  }

  return (
    <VStack align="flex-start" spacing={1}>
      <Badge
        px={3}
        py={1}
        borderRadius="full"
        fontSize="xs"
        fontWeight="bold"
        bg={colors.bg}
        color={colors.color}
        border="1px solid"
        borderColor={colors.borderColor}
        textTransform="uppercase"
      >
        {info.statusLabel}
      </Badge>
      {info.statusDetail && (
        <Text fontSize="xs" color={colors.color} fontWeight="medium">
          {info.statusDetail}
        </Text>
      )}
      {showDueDate && (
        <Text fontSize="sm" color="gray.600">
          Vence {info.dueDateFormatted}
        </Text>
      )}
    </VStack>
  );
}
